import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Page from "../Page/Page";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { Transaction_Forum } from "../../Connections/Transaction";

import "../../Styles/Introduce.css";

const Introduce = () => {
  const navigator = useNavigate();

  // =======================================

  const [info, setInfo] = useState({});

  // =======================================

  useEffect(() => {
    Transaction_Forum.GetIntroduce()
      .then((res) => {
        if (res[1] == "ok") setInfo(res[2]);
      })
      .catch((err) => console.log(err));
  }, []);

  // =======================================
  return (
    <Page>
      <MobileNavBar
        text="معرفی کتابنو"
        action={() => navigator("/hisstori/blog")}
      />
      <div className="Introduce_wrapper">
        <div
          className="Introduce_back-arrow mobile-hidden"
          onClick={() => navigator("/hisstori/blog")}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        {/* <img src={info.img} alt="ketabno Logo" /> */}
        <img src="/imgs/Blog/ketabno.svg" />
        <h1>معرفی کتابنو</h1>
        <p>
          حتما قبول داری که تو دنیای امروز، خریدن کتاب و خوندنش، همه‌جوره سخت
          شده! از هزینه‌اش بگیر که قیمت یه کتاب کوچیک اندازه پول حداقل ده گیگ
          اینترنته، تا عوض شدن سبک زندگی و دیجیتالی‌شدن همه‌چی که باعث شده آدم
          دوست داشته باشه همه‌ کاراش رو با موبایل انجام بده! این یعنی چی؟‌ یعنی
          دوره کتاب و کتابخونی دیگه گذشته؟! معلومه که نه! مگه ما مردیم؟ ما
          اینجاییم تا پرچم کتاب رو بالا نگه داریم و نه فقط بچه‌های اهل کتاب رو
          کمک کنیم، بلکه یه تعداد آدم جدید هم به جمع کتاب‌خون‌ها اضافه کنیم! چه
          جوری؟ با یه کار نو برای کتاب! با «کتابنو». کتابنو، نتیجه ساعت‌ها و
          روزها و هفته‌ها و ماه‌ها ایده‌پردازی و نمونه‌سازی و تست یه تعداد
          کتاب‌بازه و اومده تا کتابخوانی رو جذاب‌تر از همیشه کنه. فعلا قدم
          اول‌مون رو با برگزاری یه پویش شگفت‌انگیز برداشتیم. پویشی با محور خوانش
          تاریخ با عنوان «هیس‌طوری». اگه دوست داری درباره این پویش بیشتر بدونی،
          این متن رو تا آخر بخون:<br></br> شاید مجبور بشیم آتیش رو دوباره کشف
          کنیم و برای بار چندم دست به اختراع لامپ بزنیم، ممکنه از اول یاد بگیریم
          که چطور میشه از طبیعت، غذا و پوشاک به دست آورد؛ حتی شاید مجبور بشیم
          باز هم توی جنگ‌های جهانی اول و دوم قربانی بشیم و آدمای زیاد دیگه‌ای رو
          هم قربانی کنیم. همه اینا در صورتیه که به تجربه و تاریخ بی توجه باشیم.
          شاید بگید این چیزا غیر ممکنه و زمان هرگز به عقب برنمی‌گرده. اما واقعیت
          اینه که انسان گاهی اصرار داره راهی رو که به آخر رسونده، دوباره از اول
          شروع کنه. می‌گید نه؟ پنجرۀ تاریخ استعمار رو باز کنید و به تماشای جهان
          و آدماش بشینید تا بدونید چطوری روی تکرار رنج و اندوه پافشاری می‌کنه.
          تاریخ استعمار ماشین زمانیه که ما رو با کریستف کلمپ به کشف قارۀ آمریکا
          می‌بره. جاده‌ایه که ما رو با سرخپوست‌ها به کوچ اجباری می‌فرسته.
          الماسیه که برده‌های زیادی برای پیدا کردنش جونشون رو توی معادن آفریقا
          از دست دادن، پادشاهیه که از دشمناش فریب می‌خوره و دوستاش رو فریب
          می‌ده، کشتی بزرگیه که روی دریایی از خون شنا می‌کنه، پیکیه که خبرهای
          تلخ و شیرین گذشته رو توی گوش آینده زمزمه می‌کنه، و بالاخره سرگذشت
          استعمار منظره‌ای تماشاییه در انتظار چشمای ما. پس لطفا پنجره‌ها رو باز
          کنید!<br></br> تو پویش هیسطوری قراره به دنیای اسرارآمیز این کتابها سفر
          کنیم و توی دل تاریخ یه ماجراجویی هیجان‌انگیز و ترسناک داشته باشیم.
          اونم با پنج میلیارد جایزه برای دهه هشتادیا!
        </p>
        <div className="Introduce_bottom-alert">
          <img src="/imgs/common/sible.svg" alt="" />
          <div className="Introduce_bottom-alert-text-container">
            <h3>هدف کتابنو</h3>
            <p>گسترش مطالعه و لذت بردن از کتابخوانی</p>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Introduce;
